/* Belle Skin, quick-add on product cards. Intercepts clicks on [data-quick-add] spans
   inside belle-card anchors, adds the variant via AJAX, and opens the Dawn cart drawer. */
(function () {
  function add(btn) {
    if (btn.classList.contains('is-loading')) return;
    var vid = btn.getAttribute('data-vid');
    if (!vid) return;
    btn.classList.add('is-loading');
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = '';
    if (cart && cart.getSectionsToRender) {
      try { sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(','); } catch (e) {}
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: sections, sections_url: window.location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        btn.classList.remove('is-loading');
        if (resp && resp.status) return; // e.g. sold out / error
        if (cart) {
          if (cart.classList) cart.classList.remove('is-empty');
          if (cart.renderContents) cart.renderContents(resp);
        }
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-quick-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    add(btn);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest ? e.target.closest('[data-quick-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    add(btn);
  });
})();
